/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PaymentTransactionTypeEnum {
    CHARGE = 'Charge',
    VOID = 'Void',
    REFUND = 'Refund',
    REVERSAL = 'Reversal',
    ACHRETURN = 'ACHReturn',
    CHARGEBACK = 'Chargeback',
    DEPOSIT_REFUND = 'DepositRefund',
}